import GroupedBarData from '@type/sorr2025/GroupedBarData';
import { ChartConfiguration, Color } from 'chart.js';

type ColorGroup = {
    backgroundColor: Color;
    borderColor: string;
};

export type GroupedBarChartConfig = {
    labels: {
        label1: string;
        label2: string;
    };
    data: GroupedBarData[];
    colors: {
        barColor: string;
        labelColor: string;
        bar1: ColorGroup;
        bar2: ColorGroup;
    };
};

const groupedBarChartConfig = ({
    labels: { label1 = 'label 1', label2 = 'label 2' },
    data,
    colors: {
        barColor = 'white',
        labelColor = 'black',
        bar1: { backgroundColor: backgroundColor1 = 'rgb(241, 102, 81)', borderColor: borderColor1 = 'rgb(0,0,0)' },
        bar2: { backgroundColor: backgroundColor2 = 'rgb(241, 102, 81)', borderColor: borderColor2 = 'rgb(0,0,0)' },
    },
}: GroupedBarChartConfig): ChartConfiguration => {
    return {
        type: 'bar',
        data: {
            labels: data.map((row) => row.label),
            datasets: [
                {
                    label: label1,
                    data: data.map((row) => row.values.value1),
                    borderWidth: 1,
                    backgroundColor: backgroundColor1,
                    borderColor: borderColor1,
                    borderRadius: 0,
                    barThickness: 34,
                    borderSkipped: false,
                    categoryPercentage: 0.5,
                    barPercentage: 1.0,
                },
                {
                    label: label2,
                    data: data.map((row) => row.values.value2),
                    borderWidth: 1,
                    backgroundColor: backgroundColor2,
                    borderColor: borderColor2,
                    borderRadius: 0,
                    barThickness: 34,
                    borderSkipped: false,
                    categoryPercentage: 0.5,
                    barPercentage: 1.0,
                },
            ],
        },
        options: {
            indexAxis: 'y',
            maintainAspectRatio: false,
            scales: {
                x: {
                    display: false,
                    beginAtZero: true,
                    grid: {
                        display: false,
                    },
                },
                y: {
                    beginAtZero: true,
                    border: {
                        width: 0,
                    },
                    grid: {
                        display: false,
                    },
                    ticks: {
                        display: true,
                        color: '#6E2F25',
                    },
                },
            },
            plugins: {
                legend: {
                    position: 'top',
                    labels: {
                        color: labelColor,
                    },
                },
                datalabels: {
                    color: barColor,
                    formatter: (value) => {
                        return `${(value - 4).toString()}%`;
                    },
                    align: 'center',
                    anchor: 'center',
                },
                tooltip: {
                    enabled: false,
                },
            },
        },
    };
};

export default groupedBarChartConfig;
